import { render, staticRenderFns } from "./PostImageHolder.vue?vue&type=template&id=1e9c0a8e&"
import script from "./PostImageHolder.vue?vue&type=script&lang=js&"
export * from "./PostImageHolder.vue?vue&type=script&lang=js&"
import style0 from "./PostImageHolder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports